<template>
  <div class="email-box">
    <h2 class="global-title">{{ $t('email-lang') }}</h2>
    <p class="e-desc">{{ $t('email-desc') }}</p>
    <div class="lang-box">
      <div v-for="item in list" :key="item.value" class="lang-cell">
        <img
          v-if="item.value === activedLang"
          src="~img/member/icon-checked.svg"
          alt="icon-check"
        />
        <div @click="changeLang(item.value)" v-else />
        <p @click="changeLang(item.value)" :class="{ 'no-checked': item.value !== activedLang }">
          {{ item.name }}
        </p>
      </div>
    </div>
    <p class="lang-btn" @click="updateEmailLang">{{ $t('btn-save') }}</p>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'index',
    data() {
      return {
        list: [],
        activedLang: 'en_US',
      };
    },
    computed: {
      ...mapState(['userInfo']),
    },
    mounted() {
      this.getEmailLang();
    },
    methods: {
      // 获取语言列表
      async emailLangList(lang, data) {
        try {
          const { sessionId, userId } = data;
          const res = await this.$http.account.emailLangList({ lang, sessionId, userId });
          if (res?.state === '11') {
            this.$loading.hide();
            if (res.payload) {
              this.list = res.payload;
            }
          }
        } catch (err) {
          console.error(err);
          this.$loading.hide();
        }
      },
      changeLang(data) {
        this.activedLang = data;
      },
      // 修改用户邮件语言
      async updateEmailLang() {
        this.$loading.show();
        const { userId, sessionId } = this.userInfo;
        const data = {
          userId,
          sessionId,
          emailLang: this.activedLang,
        };
        try {
          const res = await this.$http.account.updateEmailLang(data);
          if (res?.state === '11') {
            this.$loading.hide();
            this.$messageModal.show({
              i18nNeed: true,
              image: false,
              title: 'msg-success-status',
              desc: 'updated.email',
              confirmBtn: 'btn-ok',
              justHide: true,
              callback: this.getEmailLang,
            });
          }
        } catch (err) {
          console.error(err);
          this.$loading.hide();
        }
      },
      // 获取用户邮件语言
      async getEmailLang() {
        const { userId, sessionId } = this.userInfo;
        const data = {
          userId,
          sessionId,
        };
        try {
          const res = await this.$http.account.getEmailLang(data);
          if (res?.state === '11') {
            this.activedLang = res.userInfo?.emailLang ? res.userInfo.emailLang : 'en_US';
            this.emailLangList(this.activedLang, data);
          }
        } catch (err) {
          console.error(err);
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .email-box {
    @include global-title();

    .e-desc {
      margin: 44px 0 28px;
      @include font(24px, 600);
      line-height: 32px;
    }

    .lang-box {
      .lang-cell {
        @include flex(row, center, flex-start);
        margin-bottom: 24px;

        p {
          margin-left: 14px;
          @include font(18px, 400);
          color: $color-blue;
          line-height: 24px;
          cursor: default;
        }

        .no-checked {
          cursor: pointer;
        }

        img,
        div {
          box-sizing: border-box;
          width: 32px;
          height: 32px;
          cursor: default;
        }

        div {
          color: $color-glod;
          cursor: pointer;
          border: solid 2px $color-glod;
          border-radius: 50%;
        }
      }
    }

    .lang-btn {
      width: 340px;
      height: 46px;
      margin-top: 64px;
      @include font(18px, 600);
      text-align: center;
      line-height: 44px;
      color: #fff;
      background: linear-gradient(90deg, #c29d5c 0%, #d4ba8d 100%);
      border-radius: 5px;
      cursor: pointer;
    }
  }

  @media screen and (max-width: 1024px) {
    .email-box {
      .global-title {
        @include font(18px, 600);
        line-height: 40px;
        padding-bottom: 12px;

        &:after {
          bottom: 0;
        }
      }

      .e-desc {
        margin-top: 16px;
        @include font(16px, 600);
        line-height: 22px;
      }

      .lang-box {
        .lang-cell {
          img,
          div {
            background-size: 25px 25px;
            width: 25px;
            height: 25px;
          }
          p {
            @include font(16px, 400);
            line-height: 22px;
          }
        }
      }
      .lang-btn {
        margin-top: 48px;
        width: 100%;
      }
    }
  }
</style>
